<template>
    <el-footer  id="contact-me"  :class="{'page-footer':!mobileBottom,'mobile-footer':mobileBottom}">
        <div :class="{'content':!mobileBottom,'mobile-content':mobileBottom}">
            <div class="lxLeft">
                <p class="lxTitle">联系我们</p>
                <p class="subLX">数字化解决方案服务商，全方位为政企提供优质服务</p>
                <div class="botTop flexBox">
                    <div class="kfBox"><span>技术服务</span></div>
                    <span class="phone">0513-85288128<label style="padding:0px 5px;font-size: 30px;font-weight: normal;">转</label>8022</span>
                </div>
                <div class="gsbox">
                    <!-- <p>公司名称：江苏海隆华思计算机系统有限公司</p> -->
                    <p>公司地址：南通市崇川路79号国际青创园1号楼11层</p>
                </div>
            </div>
            <div class="lxRight" v-if="!mobileBottom">
                <p class="gzTitle">关注我们</p>
                <div class="code">
                    <div class="codeOne">
                        <img :src="companyQr" alt="">
                        <p>公司官网</p>
                    </div>
                    <div class="codeOne">
                        <img :src="wechatQr" alt="">
                        <p>微信公众号</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottomPage" v-if="!mobileBottom">
            <span @click="geoMiittoWeb" style="cursor: pointer;">备案编号：苏ICP备19002774号-8</span>
            <span>版权所有：江苏海隆华思计算机系统有限公司</span>
            <span>Copyright © 2009 - 2023 jhs-sys.com All rights reserved.</span>
        </div>
    </el-footer>
</template>

<script>
export default {
  name: 'Mybottom',
  data () {
    return {
      mobileBottom: false,
      companyQr: require('../../../static/images/company-qr.png'),
      wechatQr: require('../../../static/images/wechat-qr.png')
    }
  },
  components: {},
  mounted () {
    if (navigator.userAgent.match(/mobile/i)) {
      this.mobileBottom = true
    }
  },
  created () {
    var protocol = window.location.protocol
    var hostname = window.location.hostname
    var port = window.location.port
    this.apiUrl = protocol + '//' + hostname + ':' + port
  },
  methods: {
    geoMiittoWeb () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 *{
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    text-align: left;
}
.mobile-footer{
    height: 250px !important;
}
.page-footer{
    height: 290px !important;
}
.el-footer{
    width: 100%;
    padding: 0px !important;
    background: url('../../../static/images/foot-bg.png') no-repeat;
    background-size: cover;
    position: relative;
}
.mobile-content{
    width: 95%;
    margin: auto;
    position: relative;
    bottom: -25px;
}
.content{
    width: 65%;
    margin: auto;
    position: relative;
    bottom: -25px;
}
.el-footer .content{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.lxTitle{
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 18px;
}
.subLX{
    font-size: 20px;
    color: #4F596D;
    margin-bottom: 25px;
}
.botTop{
    margin-bottom: 20px;
}
.flexBox{
    display: flex;
    align-items: center;
}
.kfBox span{
    color: #fff;
}
.botTop{
    margin-bottom: 20px;
}
.kfBox{
    padding: 10px;
    margin-right: 15px;
    background: #0550DC;
}
.kfBox span{
    font-size: 30px;
    letter-spacing: 3px;
    margin-left: 3px;
}
.phone{
    font-weight: 700;
    font: bold 40px "Arial";
    display: flex;
}
.gsbox p{
    font-size: 16px;
    margin-bottom: 4px;
    color: #626A7E;
}
.gzTitle{
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
}
.code{
    display: flex;
}
.codeOne img{
    width: 103px;
    height: 103px;
    margin-bottom: 15px;
}
.codeOne{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px 10px;
}
.bottomPage{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30px;
    border-top:1px solid #DCE1EB;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bottomPage span{
    color:#97A1B6;
    font-size: 14px;
}
.bottomPage span:nth-child(2){
    margin: 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/pageBottom/bottom.vue